export const news = {
  newsFeedCreateInputPlaceholder: 'Écrire un message...',
  newsFeedSearchInputPlaceholder: 'Rechercher',
  newsFeedPostOwnerCurtainEditTitle: 'Modifier le message',
  newsFeedPostOwnerCurtainDeleteTitle: 'Supprimer le message',
  newsFeedEditedPostSavedAlertText: 'Message enregistré !',
  newsFeedEditedPostDeletedAlertText: 'Message supprimé !',
  newsFeedShareCurtainOptionTitle: 'Copier le lien',
  newsFeedPostLinkCopiedAlertText: 'Lien copié !',
  newsFeedOthersPostCurtainOptionCopyTitle: 'Copier le lien',
  newsFeedOthersPosLinkCopiedAlertText: 'Lien copié !',
  newsFeedOthersPostCurtainOptionFlagTitle: 'Signaler le contenu',
  newsFeedOtherPostOwnersCurtainDeleteTitle: 'Supprimer le message',
  newsFeedPostDeletePopupTitle: 'Supprimer',
  newsFeedPostDeletePopupText: 'Supprimer ce message ?',
  newsFeedPostDeletePopupCancelButtonTitle: 'Annuler',
  newsFeedPostDeletePopupConfirmButtonTitle: 'Confirmer',
  newsFeedPostDeeletedAlertText: 'Message supprimé !',
  newsPostDetailsHeaderTitle: 'Message',
  postFeedPostLikesText: 'J`aime',
  postFeedPostCommentsText: 'Commentaires',
  postFeedPostNoLikesText: "Il n'y a pas encore de j'aime",
  postFeedPostLeaveFirstLikeText: 'Vous pouvez être le premier à aimer',
  newsFeedPostDetailsNoCommentsText: "Il n'y a pas encore de commentaires",
  newsFeedPostDetailsFirstCommentText: 'Vous pouvez être le premier à commenter',
  newsFeedPostDetailsShareOptionTitle: 'Copier le lien',
  newsFeedPostDetailsSharePostCopiedAlertText: 'Lien copié !',
  newsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Copier le lien',
  newsFeedPostDetailsCopiedAlertText: 'Lien copié !',
  newsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Signaler le contenu',
  newsPostDetailsFlagCurtainOptionSpamTitle: 'Signaler',
  newsPostDetailsReportedCurtainText: 'Contenu signalé',
  newsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Modifier le commentaire',
  newsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Supprimer le commentaire',
  newsPostDetailsEditedCommentSavedAlertText: 'Commentaire enregistré !',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Supprimer le commentaire',
  postDetailsOtherUsersCommentDeletadAlertText: 'Commentaire supprimé !',
  postDetailsDeleteCommentPopupTitle: 'Supprimer',
  postDetailsDeleteCommentPopupText: 'Supprimer ce commentaire ?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Annuler',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Confirmer',
  postDetailsCommDeletedAlertText: 'Commentaire supprimé !',
  postDetailsCommentUserCurtainOptionTitle: 'Signaler le commentaire',
  newsCreatePostCurtainTitle: 'Nouveau message',
  newsCreatePostCurtainBodyPlaceholder: 'Rédigez votre texte ici...',
  newsCreatePostPublishButtonTitle: 'Publier',
  newsCreatePostUploadSlallerImageAlertText: 'Vous ne pouvez pas télécharger plus de {size} Mo à la fois',
  newsPostSavedAlertText: 'Message enregistré !',
  newsCreatePostAddLocationCurtainTitle: 'Lieu',
  newsCreatePostAddLocationCurtainInputPlaceholder: 'Nom du lieu',
  newsCreatePostEditLocationCurtainText: 'Modifier le lieu',
  newsDeleteLocation: 'Supprimer le lieu',
  newsDiscardPostPopupTitle: 'Brouillon',
  newsDiscardPostPopupText: 'Supprimer ce brouillon ?',
  newsDiscardPostPopupCancelButtonTitle: 'Annuler',
  newsDiscardPostPopupCofirmButtonTitle: 'Confirmer',
  newsNewPostCreatePollTitle: 'Créer un sondage',
  newsNewPostCreatePollTitleInputPlaceholder: 'Titre',
  newsNewPostCreatePollOptionInputPlaceholder: 'Option',
  newsNewPostCreatePollAddButtonTitle: 'Ajouter une option',
  newsNewPostCreatePollCreateButtonTitle: 'Créer',
  newsCreatePostPollTitleBlankAlertText: 'Le titre ne peut pas être vide !',
  newsCreatePostPollOptionBlankAlertText: "L'option ne peut pas être vide !",
  newsCreatePostPollLongTitleAlertText: 'Le titre doit contenir au maximum {length} caractères',
  newsCreatePostPollLongOptionAlertText: "L'option doit contenir au maximum {length} caractères",
  newsCreatePostPollEditOptionTitle: 'Modifier le sondage',
  newsCreatePostPollRemoveOptionTitle: 'Supprimer le sondage',
  newsPostPollInfoVotesText: 'votes',
  newsPostPollInfoEditVoteText: 'Modifier le vote',
  newsPostPollFinishPollText: 'Terminer le sondage',
  newsPostPollFinishedPollText: 'Terminé',
  newsPostPollInProgresslText: 'En cours',
  newsFinishPollCurtainTitle: 'Terminer le sondage',
  newsFinishPollCurtainText: 'Les utilisateurs ne pourront plus voter une fois le sondage terminé.',
  newsFinishPollCurtainCancelButtonTitle: 'Annuler',
  newsFinishPollCurtainConfirmlButtonTitle: 'Confirmer',
  newsPollInfoPollVotesCurtainTitle: 'Votes du sondage',
  newsEditPostCurtainTitle: 'Modifier le message',
  newsEditPostCurtainNoTextBodyPlaceholder: 'Rédigez votre texte ici...',
  newsEditPostCurtainSaveButtonTitle: 'Enregistrer',
  newsEditPostSavedAlertText: 'Message enregistré !',
  newsError: 'Une erreur est survenue !',
  newsAt: 'à',
  newsSeeMore: 'Voir plus...',
  newsMaxAttachments: 'Vous avez dépassé le nombre maximal de pièces jointes. Le maximum de pièces jointes est de {length}',
  newsReply: 'Répondre',
  newsPin: 'Épingler le message',
  newsUnpin: 'Détacher le message'
}
